export default (state, param) => {
  state.form = param.form
  state.fields = param.detail
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/mutations/setOrderCustomForm.js